export default __webpack_public_path__ + "static/media/010-lobster.73649d83.svg";